import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import {
  FLAG_GETTING_CABIN_CREW_TYPES,
  GET_CABIN_CREW_TYPES,
  CLEAR_CABIN_CREW_TYPES,
} from '../types/traffic';
import { CABIN_CREW_TYPE_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';

const flagGettingCabinCrewTypes = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_CABIN_CREW_TYPES,
    payload: flag,
  });

const getCabinCrewTypes = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingCabinCrewTypes(true));
    const query = tableFilters;
    const url = `${CABIN_CREW_TYPE_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const statuses = await response.json();
    dispatch({
      type: GET_CABIN_CREW_TYPES,
      payload: statuses,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingCabinCrewTypes(false));
  }
};

const clearCabinCrewTypes = () => (dispatch) =>
  dispatch({
    type: CLEAR_CABIN_CREW_TYPES,
  });

export { getCabinCrewTypes, clearCabinCrewTypes };
